export const findLocations = (functionId?: string) => `
{
  findLocations(id: "${functionId}"){
    cities,
    state
  }
}`
